import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import type { ReactNode } from 'react'
import { onboardingTheme } from './onboardingTheme'

export function OnboardingThemeProvider({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={onboardingTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
